"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarHeading = exports.SystemFolder = exports.className = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardTypes_1 = require("../DashboardTypes");
var DashboardUtils_1 = require("../DashboardUtils");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var DashboardTypes_2 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
exports.className = "dashboard-sidebar";
var Sidebar = (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSidebarContent = function (selectedFolder) {
            var _a;
            var _b = _this.props, foldersViewStore = _b.foldersViewStore, dragDropOnFolder = _b.dragDropOnFolder, onFolderSelect = _b.onFolderSelect;
            var isFolderBeingDragged = (_a = _this.props.foldersViewStore) === null || _a === void 0 ? void 0 : _a.isFolderBeingDragged;
            var sidebarItemCommonProps = {
                dragDropOnFolder: dragDropOnFolder,
                onFolderSelect: onFolderSelect,
            };
            return (react_1.default.createElement(react_1.default.Fragment, null,
                !!foldersViewStore ? _this.renderCustomFolders() : react_1.default.createElement(FoldersHeading, null, "Folders"),
                react_1.default.createElement(SystemFolder, __assign({ name: (0, DashboardUtils_1.getTitle)(DashboardTypes_2.ProjectCollection.All), collection: DashboardTypes_2.ProjectCollection.All, active: selectedFolder === DashboardTypes_2.ProjectCollection.All, icon: react_1.default.createElement(icons_1.Folder, null) }, sidebarItemCommonProps)),
                react_1.default.createElement(SystemFolder, __assign({ name: (0, DashboardUtils_1.getTitle)(DashboardTypes_2.ProjectCollection.Archived), collection: DashboardTypes_2.ProjectCollection.Archived, active: selectedFolder === DashboardTypes_2.ProjectCollection.Archived, disable: isFolderBeingDragged, icon: react_1.default.createElement(icons_1.Archive, null) }, sidebarItemCommonProps)),
                react_1.default.createElement(SystemFolder, __assign({ name: (0, DashboardUtils_1.getTitle)(DashboardTypes_2.ProjectCollection.Deleted), collection: DashboardTypes_2.ProjectCollection.Deleted, active: selectedFolder === DashboardTypes_2.ProjectCollection.Deleted, icon: react_1.default.createElement(icons_1.Delete, null) }, sidebarItemCommonProps))));
        };
        _this.createNewFolder = function (accountLevel) {
            if (accountLevel === void 0) { accountLevel = false; }
            var foldersViewStore = _this.props.foldersViewStore;
            if (foldersViewStore && foldersViewStore.allowCreatingFolder) {
                foldersViewStore.startCreatingFolder(accountLevel);
            }
        };
        _this.onFolderDragEnd = function () {
            _this.props.foldersViewStore.setIsCustomFolderBeingDragged(false);
        };
        return _this;
    }
    Sidebar.prototype.render = function () {
        var folderSelectionViewStore = this.props.folderSelectionViewStore;
        var selectedFolder = folderSelectionViewStore.selectedFolder;
        return react_1.default.createElement("div", { className: exports.className }, this.renderSidebarContent(selectedFolder));
    };
    Sidebar.prototype.renderCustomFolders = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, this.renderAccountFolders()));
    };
    Sidebar.prototype.renderPrivateFolders = function () {
        var _this = this;
        var _a = this.props, foldersViewStore = _a.foldersViewStore, dragDropOnFolder = _a.dragDropOnFolder, onFolderSelect = _a.onFolderSelect;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.SidebarHeading, { title: "My Folders", addFolderButtonName: "Create new folder", onAddFolderClick: function () { return _this.createNewFolder(); }, allowCreatingFolder: foldersViewStore.allowCreatingFolder }),
            react_1.default.createElement("div", { onMouseDown: function (e) {
                    e.stopPropagation();
                } },
                react_1.default.createElement(kaleidoscope_1.FolderTree, { className: "".concat(exports.className, "__my-folders"), viewStore: foldersViewStore.myFoldersViewStore, maxNameLength: foldersViewStore.maxNameLength, onSelect: onFolderSelect, onDropOnFolder: dragDropOnFolder, onNameChange: foldersViewStore.onNameChange, onRenameConfirm: foldersViewStore.onRenameConfirm, onRenameCancel: foldersViewStore.onRenameCancel }))));
    };
    Sidebar.prototype.renderAccountFolders = function () {
        var _this = this;
        var _a = this.props, foldersViewStore = _a.foldersViewStore, dragDropOnFolder = _a.dragDropOnFolder, onFolderSelect = _a.onFolderSelect;
        var allowDraggingFolders = foldersViewStore ? foldersViewStore.allowDraggingFolders : true;
        var onFolderDragStart = allowDraggingFolders ? this.onFolderDragStart : undefined;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.SidebarHeading, { title: "Account Folders", addFolderButtonName: "Create account folder", onAddFolderClick: function () { return _this.createNewFolder(true); }, allowCreatingFolder: this.props.foldersViewStore.allowCreatingFolder }),
            react_1.default.createElement("div", { onMouseDown: function (e) {
                    e.stopPropagation();
                } },
                react_1.default.createElement(kaleidoscope_1.FolderTree, { className: "".concat(exports.className, "__my-folders"), viewStore: foldersViewStore.accountFolderViewStore, maxNameLength: foldersViewStore.maxNameLength, onSelect: onFolderSelect, onDragStart: onFolderDragStart, onDragEnd: this.onFolderDragEnd, onDropOnFolder: dragDropOnFolder, onNameChange: foldersViewStore.onNameChange, onRenameConfirm: foldersViewStore.onRenameConfirm, onRenameCancel: foldersViewStore.onRenameCancel, onCreateFolder: foldersViewStore.onCreateChildFolder, onDeleteFolder: this.onDeleteFolder }))));
    };
    Sidebar.prototype.onFolderDragStart = function (event, folderId) {
        event.dataTransfer.effectAllowed = "move";
        var dragData = {
            type: DashboardTypes_1.DragDataType.SidebarFolder,
            folderToMove: folderId,
        };
        event.dataTransfer.setData("application/json", JSON.stringify(dragData));
        this.props.foldersViewStore.setIsCustomFolderBeingDragged(true);
    };
    Sidebar.prototype.onDeleteFolder = function (folderId) {
        return __awaiter(this, void 0, Promise, function () {
            var _a, foldersViewStore, onFolderSelect, selectedFolderWasDeleted;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, foldersViewStore = _a.foldersViewStore, onFolderSelect = _a.onFolderSelect;
                        return [4, foldersViewStore.onDeleteFolder(folderId)];
                    case 1:
                        selectedFolderWasDeleted = _b.sent();
                        if (selectedFolderWasDeleted) {
                            onFolderSelect(DashboardTypes_2.ProjectCollection.All);
                        }
                        return [2];
                }
            });
        });
    };
    var _a, _b, _c, _d;
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _a : Object, typeof (_b = typeof kaleidoscope_2.FolderTreeId !== "undefined" && kaleidoscope_2.FolderTreeId) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], Sidebar.prototype, "onFolderDragStart", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof kaleidoscope_2.FolderTreeId !== "undefined" && kaleidoscope_2.FolderTreeId) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], Sidebar.prototype, "onDeleteFolder", null);
    Sidebar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Sidebar);
    return Sidebar;
}(react_1.default.Component));
exports.default = Sidebar;
var SystemFolder = (function (_super) {
    __extends(SystemFolder, _super);
    function SystemFolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemFolder.prototype.render = function () {
        var _a;
        var _b = this.props, active = _b.active, collection = _b.collection, dragDropOnFolder = _b.dragDropOnFolder, icon = _b.icon, onFolderSelect = _b.onFolderSelect, name = _b.name, disable = _b.disable;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
                _a["".concat(exports.className, "__system-folder")] = true,
                _a["".concat(exports.className, "__system-folder--").concat(collection)] = true,
                _a["".concat(exports.className, "__system-folder--active")] = active,
                _a)), onMouseDown: function (e) {
                e.stopPropagation();
            } },
            react_1.default.createElement(kaleidoscope_4.FolderComponent, { icon: icon, name: name, onClick: function () { return onFolderSelect(collection); }, onDrop: function (event) { return dragDropOnFolder(event, collection); }, selected: active, disableDrop: disable })));
    };
    SystemFolder = __decorate([
        mobx_react_1.observer
    ], SystemFolder);
    return SystemFolder;
}(react_1.default.Component));
exports.SystemFolder = SystemFolder;
var FoldersHeading = (0, mobx_react_1.observer)(function (props) {
    return react_1.default.createElement("div", { className: "".concat(exports.className, "__label text-context-label") }, props.children);
});
FoldersHeading.displayName = "FoldersHeading";
exports.SidebarHeading = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement(FoldersHeading, null,
        react_1.default.createElement("div", { className: "".concat(exports.className, "__folder-tree-heading"), onMouseDown: function (e) {
                e.stopPropagation();
            } },
            react_1.default.createElement("div", { id: "folder-tree-title", className: "".concat(exports.className, "__folder-tree-title") }, props.title),
            react_1.default.createElement(kaleidoscope_3.IconButton, { isRound: true, size: kaleidoscope_3.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Add, null), type: kaleidoscope_3.ButtonType.Secondary, onClick: props.onAddFolderClick, disabled: !props.allowCreatingFolder, tooltip: {
                    content: props.addFolderButtonName,
                } }))));
});
exports.SidebarHeading.displayName = "SidebarHeading";
